export const EMAIL_ACCESS_ALLOWLIST = [
  'https://sitesiftai.com',
  'https://www.sitesiftai.com',
  'https://email-automation-cache.web.app',
  'https://us-central1-email-automation-cache.cloudfunctions.net',
  'https://firestore.googleapis.com',
  'https://firebasestorage.googleapis.com',
  'https://identitytoolkit.googleapis.com',
  'https://securetoken.googleapis.com',
  'https://login.microsoftonline.com',
];

const NETWORK_OR_CALLABLE_HINTS = [
  'internal',
  'failed to fetch',
  'network',
  'cors',
  'webchannel',
  'transport errored',
];

const ADMIN_CONSENT_HINTS = [
  'aadsts65001',
  'consent_required',
  'admin consent',
  'administrator has not consented',
];

export function getEmailAccessErrorMessage(error) {
  const rawMessage = [
    error?.message,
    error?.code,
    error?.details,
  ].filter(Boolean).join(' ');
  const normalized = rawMessage.toLowerCase();

  if (ADMIN_CONSENT_HINTS.some((hint) => normalized.includes(hint))) {
    return 'Your organization still needs administrator approval for SiteSift email access. Ask IT to approve the SiteSift email access enterprise app, which may appear in Microsoft as EmailAutomation-API, for delegated Graph permissions Mail.ReadWrite, Mail.Send, and offline_access. Then come back here and click Try Again.';
  }

  if (NETWORK_OR_CALLABLE_HINTS.some((hint) => normalized.includes(hint))) {
    return `We could not start Microsoft email access from this browser. If IT already approved SiteSift, ask them to also allow these SiteSift/Firebase/Microsoft endpoints, then refresh this page and click Grant Email Access again:\n\n${EMAIL_ACCESS_ALLOWLIST.join('\n')}`;
  }

  return error?.message || 'Failed to start Microsoft email access setup. Please refresh this page and try again.';
}
